<template>
    <div class="own-the-look">
        <button class="own-the-look__btn" @click="open = true">Own the look</button>
        <div v-if="open" class="side-panel" @click.self="open = false">
            <div class="side-panel__content own-the-look__panel">
                <button class="side-panel__close" @click="open = false">
                    <img :src="$cdn('/img/ui/icon-close.svg')" alt="Close" width="14" height="14">
                </button>
                <p class="own-the-look__store">{{ storeName }}</p>
                <div class="own-the-look__image">
                    <img v-if="image" :src="image" :alt="product.name" @error="image = null">
                    <img v-else :src="$cdn($root.brand.logo_symbol)" :alt="product.name" width="64" height="64">
                </div>
                <span class="own-the-look__category">{{ product.category }}</span>
                <h4 class="own-the-look__name">{{ product.name }}</h4>
                <p class="own-the-look__rating">&#9733; {{ product.rating }} <span>/ {{ product.reviews }} reviews</span></p>
                <p class="own-the-look__price">
                    {{ product.price }}
                    <s>{{ product.wasPrice }}</s>
                    <span>{{ product.discount }}</span>
                </p>
                <p class="own-the-look__label">Color: {{ product.color }}</p>
                <div class="own-the-look__swatches">
                    <button
                        v-for="swatch in product.swatches"
                        :key="swatch"
                        :style="{ backgroundColor: swatch }"
                        :class="{ selected: swatch === product.swatch }"
                    ></button>
                </div>
                <p class="own-the-look__label">Size</p>
                <div class="own-the-look__sizes">
                    <button
                        v-for="size in product.sizes"
                        :key="size"
                        :class="{ selected: size === selectedSize }"
                        @click="selectedSize = size"
                    >{{ size }}</button>
                </div>
                <div class="own-the-look__buy">
                    <div class="own-the-look__quantity">
                        <button @click="quantity = Math.max(1, quantity - 1)">&minus;</button>
                        <span>{{ quantity }}</span>
                        <button @click="quantity += 1">+</button>
                    </div>
                    <a class="own-the-look__cart" :href="$root.brand.store_link" target="_blank" rel="noopener">Add to cart</a>
                </div>
                <p class="own-the-look__returns">Return &amp; Exchange<br><span>Free 30 Days Delivery &amp; Returns</span></p>
            </div>
        </div>
    </div>
</template>

<script>
// Mocked KLEKT store panel (Phase 1) - static product data, no live integration.
// The "Add to cart" button links out to the configured brand store.
export default {
    name: 'OwnTheLook',
    data() {
        return {
            open: false,
            image: this.$root.post?.thumbnail ?? null,
            storeName: 'KLEKT',
            quantity: 1,
            selectedSize: 'M',
            product: {
                category: 'Apparel',
                name: 'Supreme Jordan Hooded Leather Jacket',
                rating: '4.5',
                reviews: 130,
                price: '£806',
                wasPrice: '£950',
                discount: '-15%',
                color: 'Pink',
                swatch: '#e75480',
                swatches: ['#000000', '#e75480', '#3fc3d2', '#f3f3f3'],
                sizes: ['XS', 'S', 'M', 'L', 'XL']
            }
        }
    }
}
</script>
